import $ from 'jquery';
import PubSub from 'pubsub-js';
import debounce from '../helpers/debounce';
import { filterString } from '../helpers/filterString';

class SortableItem {

  constructor(sortable) {
    this.config;

    this.config = $(sortable).data('sortable');
    this.items = $(this.config.target).children('*[data-sortable-item]');

    if (this.config.type == 'button') {
      $(sortable).on('click', '*[data-pick]', (event) => {
        let thisBt = $(event.target);
        let pickable = $(thisBt).data('pick');

        $(event.delegateTarget).find('.is-active').removeClass('is-active');
        thisBt.addClass('is-active');

        PubSub.publish('SortableItem.button.changed', {
          picked: pickable,
          criteria: this.config.criteria,
          sortable: this
        });
      })
    } else if (this.config.type == 'input') {
      let debouncedKeyUp = debounce(context => {
        // console.log(context.target.value);
        PubSub.publish('SortableItem.button.changed', {
          picked: context.target.value,
          criteria: this.config.criteria,
          sortable: this
        });

      }, 100);

      $(sortable).on('keyup', 'input[data-pick]', event => {
        debouncedKeyUp(event);
      });
    }

  }
}

class Sortable {

  constructor() {
    this.startedItems = [];
    this.picked = [];

    const sortables = $('*[data-sortable]');
    if (sortables.length) {
      sortables.each((index, sortable) => {
        this.init(sortable);
      });

      PubSub.subscribe('SortableItem.button.changed', (msg, data) => {
        this.picked = this.picked.filter(pick => {
          if (pick.criteria != data.criteria) {
            return pick;
          };
        });

        if ( !(data.picked == 'all' || data.picked == '') ) {
          this.picked.push(data);
        }

        $(data.sortable.items).each((index, item) => {
          let isPicked = [];

          for (let pick of this.picked) {
            let hasSomePicked = this.picked.some(pick => {
              let isATruth;

              if (pick.sortable.config.type == 'input') {
                let filteredCriteria = filterString( $(item).data(pick.criteria) );
                isATruth = filteredCriteria.indexOf(pick.picked) > -1;
              } else {
                isATruth = pick.picked == $(item).data(pick.criteria);
              }

              if (isATruth) {
                isPicked.push(true);
              } else {
                isPicked.push(false);
              }
            })
          }

          // check if all picks are true - exist on all criteria
          if(isPicked.indexOf(false) < 0) {
            $(item).removeClass('hide');
          } else {
            $(item).addClass('hide');
          }
        });

      });
    }
  }

  init(sortable) {
    this.startedItems.push( new SortableItem(sortable) );
  }
}

export default new Sortable;
